export default __webpack_public_path__ + "static/illustration-action.url-adb89247c5b0607028a66b738c9b2c9d.svg";